import { render } from "./SegmentInputText.vue?vue&type=template&id=1b9bceb4&scoped=true"
import script from "./SegmentInputText.vue?vue&type=script&lang=ts"
export * from "./SegmentInputText.vue?vue&type=script&lang=ts"

import "./SegmentInputText.vue?vue&type=style&index=0&id=1b9bceb4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b9bceb4"

export default script